import React, { useEffect, useState } from "react";
import { Button, Input, Label, Spinner } from "reactstrap";
import {
  createClientInput,
  toggleTaskClientInput,
  toggleSubTaskClientInput,
  getTaskClientInput,
  getSubTaskClientInput
} from "../../Api/ApiUrlConst";
import { useAuth } from "../../Context/AuthContext";

interface Props {
  entityType: "task" | "subtask"|"childSubTask";
  entityId: number;
  onSuccess: () => void;
}

const ClientInputForm: React.FC<Props> = ({
  entityType,
  entityId,
  onSuccess
}) => {
  const { role } = useAuth();
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // 🔥 ALWAYS LOAD FROM DB
  useEffect(() => {
    const loadStatus = async () => {
      try {
        const res =
          entityType === "task"
            ? await getTaskClientInput(entityId)
            : await getSubTaskClientInput(entityId);

        setEnabled(res.data.isClientInputEnabled);
      } catch {
        setEnabled(false);
      }
    };

    loadStatus();
  }, [entityType, entityId]);

  const toggleEnabled = async (checked: boolean) => {
    setLoading(true);
    try {
      if (entityType === "task") {
        await toggleTaskClientInput(entityId, checked);
      } else {
        await toggleSubTaskClientInput(entityId, checked);
      }

      // 🔄 RE-FETCH FROM DB
      const res =
        entityType === "task"
          ? await getTaskClientInput(entityId)
          : await getSubTaskClientInput(entityId);

      setEnabled(res.data.isClientInputEnabled);

    } finally {
      setLoading(false);
    }
  };

const submit = async (e?: React.MouseEvent) => {
  e?.preventDefault(); // extra protection
  if (!message.trim()) return;

  setLoading(true);
  try {
    await createClientInput({
      message,
      taskId: entityType === "task" ? entityId : undefined,
      subTaskId: entityType === "subtask" ? entityId : undefined
    });
    setMessage("");
    onSuccess();
  } finally {
    setLoading(false);
  }
};

const radioName = `clientInput-${entityType}-${entityId}`;
  return (
    <form
  onSubmit={(e) => {
    e.preventDefault();
    submit();
  }}
>

    <div className="mt-3">
      <Input
        value={message}
        onChange={e => setMessage(e.target.value)}
        placeholder="Ask client for input..."
        disabled={!enabled || loading}
      />

      <div className="d-flex align-items-center gap-3 mt-2">


       {role === "TeamLeader" && (
  <div className="d-flex align-items-center gap-4">
    {loading && <Spinner size="sm" />}

    {/* Need Input */}
    <div className="form-check form-check-inline">
      <Input
        type="radio"
        name={radioName}
        checked={enabled === true}
        onChange={() => {
          if (!enabled) toggleEnabled(true);
        }}
        disabled={loading}
      />
      <Label className="form-check-label">
        Need Input
      </Label>
    </div>

    {/* Received All Input */}
    <div className="form-check form-check-inline">
      <Input
        type="radio"
        name={radioName}
        checked={enabled === false}
        onChange={() => {
          if (enabled) toggleEnabled(false);
        }}
        disabled={loading}
      />
      <Label className="form-check-label">
        Received all Input
      </Label>
    </div>
  </div>
)}

  <Button
  color="primary"
  type="submit"
  disabled={!enabled || loading}
>
  Save
</Button>


      </div>
    </div>
    </form>
  );
};

export default ClientInputForm;
